import { defa }  from 'defa-object';
import Dummy     from 'dummy-fetch-objects';
import UnitTests from 'scripts/defa/unit-tests/collection-unit-tests';
/**
 * defa.models.Unit
 * The DEFA Unit model.
 * @version 1.2.0
 */
import Model     from 'scripts/poppet/model';

const channel = Bb.Radio.channel( 'objects' );

const apiHost = defa.vars.apiHost;

const api = {
	units                    : apiHost + '/units',
	registration             : apiHost + '/units/registration/%s',
	serial                   : apiHost + '/units/serial/%s',
	available                : apiHost + '/units/serial/%s/available',
	firmware                 : apiHost + '/units/%s/firmware',
	token                    : apiHost + '/units/%s/transienttoken',
	tests                    : apiHost + '/units/%s/test',
	complaint                : apiHost + '/units/%s/complaint',
	forward                  : apiHost + '/units/%s/forward',
	showTests                : apiHost + '/units/%s/testresults',
	alias                    : apiHost + '/units/%s/alias',
	notes                    : apiHost + '/units/%s/notes',
	subscriptionPackage      : apiHost + '/units/%s/transientsubscriptionpackage',
	removeSubscriptionPackage: apiHost + '/units/%s/removetransientsubscriptionpackage',
	updatecomplete           : apiHost + '/units/%s/updatecomplete',
	vehicleTypes             : apiHost + '/units/%s/vehicletypesavailable',
	reset                    : apiHost + '/units/%s/reset',
	linkcomCached            : apiHost + '/linkcom/%s/cached',
	linkcomFresh             : apiHost + '/linkcom/%s'
};

const Unit = Model.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	urlRoot: api.units,
	
	defaults: {
		// data model vars
		alias       : '',
		notes       : '',
		type        : '',
		serialNumber: '',
		family      : '',
		
		tested     : !1,
		testResults: '',
		
		endpoints: !1,
		
		transientOffline            : !1,
		transientSettingsAutomotive : !1,
		transientSettingsHome       : !1,
		transientAlarmCentral       : !1,
		transientFirmware           : !1,
		transientInsuranceCompany   : !1,
		transientSecurity           : !1,
		transientSubscription       : !1,
		transientSubscriptionPackage: !1,
		transientInstallerId        : !1,
		transientInstallerName      : '',
		transientLegacyType         : null,
		
		// bluetooth options
		transientHardwareVersion : null,
		transientBuildNumber     : null,
		transientApiVersion      : null,
		transientUpgradeAvailable: false,
		transientNotifications   : false,
		
		transientIsConfiguring   : null,
	},
	
	completeList: [ 'serialNumber', ],
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	fetchCachedCapabilities: function () {
		
		let self = this;
		
		this.fetch( {
				url: api.linkcomCached.replace( '%s', this.get( 'id' ) ),
			} )
			.done( function ( response ) {
				console.log( 'great success - found cached capabilities' );
				self.trigger( 'loaded:capabilities:cached', response );
			} )
			// !TODO - remove fake response fail condition.
			.fail( function ( response ) {
				console.error( 'Unit.fetchCachedCapabilities failed, returning dummy response!' );
				self
					.set( 'endpoints', Dummy.capabilitiesCache.endpoints )
					.trigger( 'loaded:capabilities:cached', Dummy.capabilitiesCache );
			} );
		
	},
	
	/**
	 * Fetches the capabilities of the unit.
	 * @void
	 */
	fetchCapabilities: function () {
		
		let self = this;
		
		this.fetch( {
				url: api.linkcomFresh.replace( '%s', this.get( 'id' ) ),
			} )
			.done( function ( response ) {
				console.log( 'great success - found fresh capabilities' );
				self.trigger( 'loaded:capabilities:fresh', response );
			} )
			// !TODO - remove fake response fail condition.
			.fail( function ( response ) {
				console.log( 'Unit.fetchCapabilities failed, returning dummy response!' );
				self
					.set( 'endpoints', Dummy.capabilitiesCache.endpoints )
					.trigger( 'loaded:capabilities:fresh', Dummy.capabilitiesCache );
			} );
	},
	
	// - unit params
	
	/**
	 * Requests a token from the backend.
	 * @param {Object} options  Options needed to get a token, most importantly "installer".
	 * @void
	 */
	getToken: function ( options ) {
		this.fetch( {
			data       : options,
			processData: true,
			url        : api.token.replace( '%s', this.get( 'id' ) ),
		} );
	},
	
	/**
	 * Get's the UnitType from the defa.vars.unitTypes array.
	 * @return {String} The name of the UnitType of this Unit instance.
	 */
	getUnitType: function () {
		return (_.findWhere( defa.vars.unitTypes, {
			id: (this.get( 'type' ) || '')
			}) || '').name  || '';
	},
	
	// - unit fetch methods
	
	/**
	 * Fetches available vehicle types.
	 * @void
	 */
	fetchVehicleTypes: function () {
		let self = this;
		
		$.get( api.vehicleTypes.replace( '%s', this.get( 'id' ) ) )
		 .done( function ( response ) {
			 self.trigger( 'done', response );
		 } )
		 .fail( function ( response ) {
			 self.trigger( 'error', response );
		 } );
		
	},
	
	/**
	 * Fetches a unit by serial number.
	 * @void
	 */
	fetchBySerial: function ( options ) {
		let baseUrl = ( 'available' === options.context )
					  ? api.available
					  : api.serial;
		
		this.fetch( {
			url: baseUrl.replace( '%s', options.serial ),
		} );
	},
	
	/**
	 * Fetches a unit by registration number.
	 * @void
	 */
	fetchByRegistration: function ( options ) {
		this.fetch( {
			url: api.registration.replace( '%s', options.registrationNumber ),
		} );
	},
	
	/**
	 * Fetches a bluetooth unit for the web application.
	 * @void
	 */
	fetchBluetooth: function ( options ) {
		if ( defa.vars.android ) {
			window.android.openBleUnit( options.serial );
		}
		if ( defa.vars.webkit ) {
			window.webkit.messageHandlers.openBleUnit.postMessage( options.serial );
		}
	},
	
	// - unit test methods
	
	/**
	 * Waits for a pending update.
	 * @void
	 */
	updateComplete: function () {
		
		let self = this;
		
		let data = ( this.get( 'transientLegacyType' ) )
				   ? { legacyType: this.get( 'transientLegacyType' ) }
				   : false;
		
		$.ajax( {
			 method: 'GET',
			 url   : api.updatecomplete.replace( '%s', self.get( 'id' ) ),
			 data  : data,
		 } )
		 .done( function () {
			 self.trigger( 'updated' );
		 } )
		 .fail( function ( response ) {
			 self.trigger( 'error', response );
		 } );
		
	},
	
	/**
	 * Tests the unit for upgraded firmware
	 * @void
	 */
	updateFirmware: function () {
		
		let self = this,
			id   = self.get( 'id' ),
			url  = api.firmware.replace( '%s', id );
		
		$.ajax( {
			 url: url,
		 } )
		 .done( function () {
			 self.set( 'transientFirmware', true );
			 self.trigger( 'firmware:upgraded' );
		 } )
		 .fail( function () {
			 self.trigger( 'firmware:error' );
		 } );
	},
	
	/**
	 * Tests the unit for functionality / placement
	 * @void
	 */
	testFunctionality: function ( inOptions ) {
		let options = inOptions || {},
			self    = this,
			id      = self.get( 'id' ),
			url     = ( _.isBoolean( options.newTest ) && !options.newTest )
					  ? api.showTests.replace( '%s', id )
					  : api.tests.replace( '%s', id );
		
		$.ajax( {
			 url: url,
		 } )
		 .done( function ( response ) {
			 let tests    = new UnitTests( response.functionality ),
				 feedback = response.feedback;
			
			 self.trigger( 'tests:complete', tests, feedback );
		 } )
		 .fail( function ( response ) {
			 let error = response.responseJSON;
			 self.trigger( 'tests:failed', error );
		 } );
	},
	
	// - unit save methods
	
	/**
	 * Any save should always cap the Unit alias to 40 characters.
	 * @void
	 */
	save: function ( attrs, options ) {
		if ( attrs.alias ) {
			attrs.alias = attrs.alias.substring( 0, 40 );
		}
		
		Bb.Model.prototype.save.call( this, attrs, options );
	},
	
	/**
	 * Saves the unit for reset.
	 * @void
	 */
	saveReset: function () {
		this.save( {
			// nothing..
		}, {
			url: api.reset.replace( '%s', this.get( 'id' ) ),
		} );
	},
	
	/**
	 * Saves the test successfully for the User.
	 * @void
	 */
	saveTest: function () {
		this.save( {
			tested: true,
		}, {
			patch: true,
			url  : api.tests.replace( '%s', this.get( 'id' ) ),
		} );
	},
	
	/**
	 * Saves this unit's new alias.
	 * @param {String} alias  This unit's new alias.
	 * @void
	 */
	saveAlias: function ( options ) {
		if(this.isBluetooth()) {
			this.set('alias', options.alias);
			this.trigger( 'alias:changed', this );
			this.trigger( 'sync', this );
		} else {
			this.save( options, {
				patch: true,
				url  : api.alias.replace( '%s', this.get( 'id' ) ),
			} );
		}
	},
	
	saveNotes: function( options ){
		this.save( options, {
			patch: true,
			wait : true,
			url  : api.notes.replace( '%s', this.get( 'id' ) ),
		} );
	},
	
	/**
	 * Saves this unit's subscriptionPackage.
	 * @param {Object} options  Items to be saved.
	 * @void
	 */
	saveSubscriptionPackage: function ( options ) {
		this.save(
			options,
			{
				patch: true,
				wait : true,
				url  : api.subscriptionPackage.replace( '%s', this.get( 'id' ) ),
			}
		);
	},
	
	/**
	 * Saves this unit's subscriptionPackage.
	 * @param {Object} options  Items to be saved.
	 * @void
	 */
	removeSubscriptionPackage: function ( options ) {
		this.save(
			options,
			{
				patch: true,
				wait : true,
				url  : api.removeSubscriptionPackage.replace( '%s', this.get( 'id' ) ),
			}
		);
	},
	
	/**
	 * Saves a customer's email, for forwarding a subscription.
	 * @param {String} email  The recipients email.
	 * @void
	 */
	saveForward: function ( inOptions ) {
		let self    = this;
		let options = {
			url        : api.forward.replace( '%s', self.get( 'id' ) ),
			contentType: 'application/json',
			method     : 'PUT',
			data       : JSON.stringify( {
				email    : inOptions.email,
				installer: inOptions.installer,
			} ),
		};
		
		// fake the return coming from self view's model.
		$.ajax( options )
		 .done( function ( response ) {
			 self.trigger( 'success', self, response );
			 self.parse( response );
		 } )
		 .fail( function ( response ) {
			 self.trigger( 'error', self, response );
		 } );
	},
	
	/**
	 * Changes the unit within the subscription. ( TODO: Rename this function, call it concession? Something else? )
	 * @param {Object} options  An options containing both a unit and a transientInstaller.
	 * @void
	 */
	complaint: function ( options ) {
		
		this.save( options, {
			patch: true,
			url  : api.complaint.replace( '%s', this.get( 'id' ) ),
		} );
		
	},
	
	
	// - unit parse methods
	
	/**
	 * Prepares a data response to this model's attributes.
	 * @void
	 */
	parse: function ( response ) {
		if ( response ) {

			if ( response.customer ) {
				channel.request( 'customers' ).add( response.customer, { merge: true } );
			}
			
			if ( response.settingsAutomotive ) {
				channel.request( 'settingsAutomotives' ).add( response.settingsAutomotive, { merge: true } );
			}

			if ( response.settingsHome ) {
				channel.request( 'settingsHomes' ).add( response.settingsHome, { merge: true } );
			}
			
			if ( response.subscription ) {
				channel.request( 'subscriptions' ).add( response.subscription, { merge: true } );
			}
			
			if ( response.subscriptionPackage ) {
				channel.request( 'subscriptionPackages' ).add( response.subscriptionPackage, { merge: true } );
			}
			
			if ( response.alarmCentral ) {
				channel.request( 'alarmCentrals' ).add( response.alarmCentral, { merge: true } );
			}
			
			if ( response.insuranceCompany ) {
				channel.request( 'insuranceCompanies' ).add( response.insuranceCompany, { merge: true } );
			}
			
			if ( response.unit ) {
				response = response.unit;
			}
			
			channel.request( 'units' ).add( response, { merge: true } );
		}
		
		return response;
	},
	
	isAutomotive: function () {
		return 'AUTOMOTIVE' === this.get( 'family' );
	},
	
	isHome: function () {
		return 'HOME' === this.get( 'family' );
	},
	
	isBluetooth: function () {
		return 'BLUETOOTH' === this.get( 'family' );
	},
	
	isPro: function(){
		return 104 === this.get('type');
	},
	
	/**
	 * Gets the connected InsuranceCompany's name, if it exists.
	 * @return {String/bool}  The name of the InsuranceCompany if it exists, false if not.
	 */
	insuranceCompanyName: function () {
		return ( this.get( 'transientInsuranceCompany' ) )
			   ? channel.request( 'insuranceCompanies' ).get( this.get( 'transientInsuranceCompany' ) ).get( 'name' )
			   : false;
	},
	
	/**
	 * Gets the connected AlarmCentral's name, if it exists.
	 * @return {String/bool}  The name of the AlarmCentral if it exists, false if not.
	 */
	alarmCentralName: function () {
		return ( this.get( 'transientAlarmCentral' ) )
			   ? channel.request( 'alarmCentrals' ).get( this.get( 'transientAlarmCentral' ) ).get( 'name' )
			   : false;
	},
	
	/**
	 * Gets the connected Customer's name, if it exists.
	 * @return {String/bool}  The name of the Customer if it exists, false if not.
	 */
	customerName: function () {
		
		let subscription = channel.request( 'subscriptions' ).get( this.get( 'transientSubscription' ) );
		
		return ( subscription )
			   ? channel.request( 'customers' ).get( subscription.get( 'owner' ) ).name()
			   : false;
	},
	
	/**
	 * Get a name from the connected settingsAutomotive, if it exists.
	 * @return {string/boolean}  The name of the Vehicle if it exists, false if not.
	 */
	vehicleName: function () {
		if ( 'AUTOMOTIVE' !== this.get( 'family' ) ) {
			return false;
		} else {
			
			let settingsAutomotive = channel.request( 'settingsAutomotives' ).get( this.get( 'transientSettingsAutomotive' ) );
			if ( settingsAutomotive ) {
				return settingsAutomotive.name();
			}
		}
	},
	
	hasSubscription: function () {
	return this.get('transientSubscription');
	},
	
	/**
	 * Gets the connected Subscription or SubscriptionPackage's name, if either exists.
	 * @return {String/bool}  The name of the Subscription or the name of the SubscriptionPackage, or false if neither
	 *     exist.
	 */
	subscriptionName: function () {
		
		let subscription = channel.request( 'subscriptions' ).get( this.get( 'transientSubscription' ) );
		
		if ( subscription ) {
			return subscription.get( 'transientName' );
		} else {
			return ( this.get( 'transientSubscriptionPackage' ) )
				   ? channel.request( 'subscriptionPackages' ).get( this.get( 'transientSubscriptionPackage' ) ).get( 'transientName' )
				   : false;
		}
	},
	
} );

export default Unit;
